var _style, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWantingToBenchmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#ECF2FA;}\n\t.st1{fill:none;stroke:#1930AB;stroke-width:15;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#1930AB;stroke-width:15;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M318.4,41.3c0,0,202.7,139.8,169.6,302.9c0,0-34.4,170.3-313.4,137.5c-52.2-6.1-100.1-30.9-131.4-70.3 C27.9,392,16.4,369.9,9.5,346.2C-4,301.4,2,253.2,24.7,211.5C74.3,120.4,190.5-52.7,318.4,41.3"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "269.9,255.8 325.5,203.9 356.1,229.4 385.3,116.2 271.8,148.3 298.7,175.2 236.6,235.1 191.6,193.9  108.7,275.4 133.9,301.3 191.6,245.4 206.3,259.7  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M304.9,381.6c-0.6-30.9-26.3-55.8-57.9-55.8s-57.3,24.9-57.9,55.8H304.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M136.2,383.2v-12.2c0-4.8,3.6-8.8,8.4-9.4l15.7-2.1c3.3-0.4,6.2-2.5,7.6-5.6l3.2-7c1.5-3.3,1-7.2-1.4-10 l-9-10.7c-3.2-3.8-3-9.3,0.5-12.8l15.5-15.5c3.4-3.4,8.8-3.8,12.7-1l12.7,9.3c3,2.2,6.9,2.5,10.2,0.8l6.5-3.3c2.7-1.4,4.6-4,5.1-7 l2.5-15.3c0.8-4.7,4.9-8.1,9.7-8l21.7,0.4c4.6,0.1,8.5,3.3,9.3,7.8l3.1,16.3c0.6,3.4,3.1,6.1,6.4,7.3l7.1,2.4c3.1,1,6.5,0.5,9-1.4 l12.3-9.2c3.9-3,9.5-2.5,12.9,1l15.5,16.2c3.2,3.4,3.5,8.5,0.7,12.2l-9.3,12.4c-2,2.6-2.5,6.1-1.2,9.1l1.9,4.8 c1.2,3.1,3.9,5.3,7.2,5.9l17.2,3.2c4.7,0.9,8,4.9,7.9,9.6l-0.3,10.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 119.3,
    y1: 383.8,
    x2: 374.7,
    y2: 383.8
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWantingToBenchmark);
export default __webpack_public_path__ + "static/media/wanting_to_benchmark .7d107ed6ec665529855e30ed6ac7c2dd.svg";
export { ForwardRef as ReactComponent };